import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import { AiOutlinePrinter } from "react-icons/ai"
import moment from 'moment';
import { IoAddSharp } from "react-icons/io5";
import { GrEdit } from "react-icons/gr";
import { FaRegEye } from "react-icons/fa6";
import Pagination from '../pagination/pagination';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from 'react-spinners';

const InvoiceList = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL
    let navigate = useNavigate();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRow, setSelectedRow] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [selectedtem, setSelectedItem] = useState(null);
    const apiService = new ApiService();
    const [pagination, setPagination] = useState();
    const [searchLoader, setLoader] = useState(false);
    const [suppliers, setSupplier] = useState([])

    const [form, setForm] = useState({
        reqNo: "",
        poNo: "",
        vendorName: "",
        status: [{ label: 'All', value: 'All' }],
    });
    const StatusFilter = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '5', label: 'Hold' },
        { value: '2', label: 'Rejected' },
    ];
    useEffect(() => {
        fetchData()
        getItems();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Invoice");
        setPermissions(permissions[0]);
    }, []);

    const fetchData = async () => {
        try {
            const response = await apiService.get('GET_SUPPLIER_KANOO');
            setSupplier(response?.data?.result);
        } catch (error) {
            console.error("Error fetching stock data:", error);
        }
    };
    const handlePrint = () => {
        if (selectedRow) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "reportName", value: "Invoice" },
                    { name: "voucherNo", value: selectedRow?.invoiceRegNo },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }

            // navigate(`/Inventory/invoice/Print/${selectedRow?.invoiceRegNo}`, { state: selectedRow })
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('Status', form?.status?.value || "");
            params.append('InvoiceRegNo', form?.reqNo || "");
            params.append('POrderNo', form?.poNo || "");
            params.append('QuotationRef', form?.vendorName?.label || "");
            const res = await apiService.getApiParamater('GET_INVOICE', `?${params.toString()}`);
            setPagination(res.data.paginationData)
            setRowData(res?.data?.result || []);
            setLoader(false);

        } catch (error) {
            console.error('Error fetching items:', error);
            setLoader(false);
        }
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : "";
    };
    const Comparison = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        { headerName: 'Invoice No', field: 'invoiceRegNo', suppressMovable: true, width: 180 },
        { headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 180 },
        {
            headerName: 'Invoice Date', field: 'invoiceDate', suppressMovable: true, width: 180,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Vendor Name', field: 'vendorName', suppressMovable: true, width: 220 },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 220 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 220 },
        {
            headerName: 'Due Date', field: 'dueDate', suppressMovable: true, width: 180,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        {
            headerName: 'Status', field: 'status',
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }, suppressMovable: true, width: 160
        }
    ];
    const handlenew = () => {
        navigate('/Inventory/invoice/Create')
    }
    const handleEye = (clickedRowData) => {
        if (clickedRowData?.invoiceRegNo) {
            const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
            navigate(`/Inventory/invoice/${clickedRowData?.invoiceRegNo}`, { state: updatedData });
        } else {
            const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
            navigate(`/Inventory/invoice/${selectedRow?.invoiceRegNo}`, { state: updatedData });
        }
    }
    const handleEdit = () => {
        if (selectedRow?.status === 1 || selectedRow?.status === 5) {
            let eye = true
            const updatedData = { ...selectedRow, eye: eye };
            navigate(`/Inventory/invoice/Update`, { state: updatedData });
        } else {
            navigate(`/Inventory/invoice/Update`, { state: selectedRow });
        }
    };
    const onCellClicked = (event) => {
        if (event.colDef.field === 'invoiceNo') {
            const clickedRowData = event.data;
            handleEye(clickedRowData)
        }
    };
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
        const params = new URLSearchParams();
        params.append('DocNo', selectedRows[0]?.invoiceRegNo);
        params.append('DocumentType', "Invoice");
        try {
            const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
            const hasRestrictedStatus = res?.data?.result?.some(item => item.status === 1 || item.status === 5);
            if (hasRestrictedStatus) {
                console.warn("Restricted status found in the response. Skipping state update.");
                setSelectedItem(null)
                return;
            } else {
                setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
            }
        } catch (error) {
            setSelectedItem(null)
            console.error("Error fetching document status:", error);
        }
    };
    const handleClearFilters = () => {
        const clearedFormData = {
            reqNo: "",
            poNo: "",
            vendorName: "",
            status: [{ label: 'All', value: 'All' }],
        };
        setForm(clearedFormData);
        getItems(1, clearedFormData);
    };
    const handleInputChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handlelocChange = (selectedOption) => {
        setForm({ ...form, status: selectedOption });
    };
    const handleSupplierChange = (selectedOption) => {
        setForm({ ...form, vendorName: selectedOption });
    };

    return (
        <div className='p-4'><div className='gridBg justify-content-between d-flex align-items-center' style={{ borderRadius: "16px 16px 0px 0px" }}>
            <div className='mainInvHead'>Supplier Invoice</div>
            <div className='d-flex justify-content-end gap-1'>
                <div
                    onClick={handleEye}
                    className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                    style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                >
                    <FaRegEye color='#fff' className='center mt-1' />
                    <div className='center'>View</div>
                </div>
                <div
                    onClick={handlePrint}
                    className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                    style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                >
                    <AiOutlinePrinter color='#fff' className='center mt-1 ' />
                    <div className='center'>Print</div>
                </div>
                {permissions?.canUpdate === true ?
                    <div
                        onClick={selectedtem && selectedtem?.state === "Posted" ? null : handleEdit}
                        className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.state === "Posted" ? 'disabled' : ""
                            }`}
                        style={{
                            cursor: selectedtem && selectedtem?.state === "Posted" ? 'not-allowed' : "pointer",
                        }}
                    >
                        <GrEdit color='#fff' className='center mt-1 ' />
                        <div className='center'>Edit</div>
                    </div> : ''
                }
                {permissions?.canAdd === true ?
                    <div className='col center'>
                        <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                            <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                        </button>
                    </div>
                    : ''
                }
            </div>
        </div>

            <div className="p-4 border-box2 ">
                <div className='row d-flex justify-content-between'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Invoice No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={form.reqNo}
                            name="reqNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">POrder No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={form.poNo}
                            name="poNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col-3'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems(1)} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                </div>
                <div className='row mt-2 d-flex jusitfy-content-end'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Vendor Name</label>
                        <Select
                            value={form?.vendorName}
                            className="w-100 p-0"
                            options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Status</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 2,
                                height: 25,
                                minHeight: 25
                            })}
                            className="w-100 p-0"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={form?.status}
                            onChange={(selectedOption) => handlelocChange(selectedOption)}
                            options={StatusFilter}
                        />
                    </div>
                    <div className='col-3'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={rowData}
                        enableFilter={true}
                        floatingFilter={true}
                        columnDefs={Comparison}
                        onCellClicked={onCellClicked}
                        onSelectionChanged={onSelectionChanged}
                    />
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default InvoiceList; 